import _ from 'underscore';
import type { AjaxData, ErrorCodeList } from '../types';

/**
 * OdataErrorMapper - Maps ajax errors from odata calls to known user errors
 */
export class OdataErrorMapper {
 errorCodes: ErrorCodeList;
 /**
  * @param {object} errorCodes - odata user error codes
  */
 constructor(errorCodes: ErrorCodeList) {
   this.errorCodes = errorCodes || [];
 }

 /**
  * Checks if an ajax error is a known user error
  * @param {object} ajaxData - data related to the current ajax call
  * @returns {bool} - if the error maps to a known error or not
  */
 check(ajaxData: AjaxData) {
   const errorString = ajaxData.error || '';

   return _.any(this.errorCodes, errorCode => errorString.toUpperCase().indexOf(String(errorCode)) >= 0);
 }
}
